import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $nodesOfType } from "lexical";
import { BeautifulMentionNode, BeautifulMentionsPlugin } from "lexical-beautiful-mentions";
import { get } from "lodash";
import { useEffect } from "react";

import { useGetMentions } from "../api/useGetMentions";
import { LexicalEditorMentionsMenu } from "../components/mentions/menu";
import { LexicalMentionsMenuItem } from "../components/mentions/menu-item";

interface MentionsPluginProps {
  mentionEndpoint: string;
  setValue: (key: string, mentioned_account_ids: number[] | string) => void;
}

export function MentionsPlugin({ mentionEndpoint, setValue }: MentionsPluginProps) {
  const { mentions } = useGetMentions(mentionEndpoint);
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.registerUpdateListener(({ editorState }) => {
      editorState.read(
        () => {
          const mentionNodes = $nodesOfType(BeautifulMentionNode);

          const mentionsData = mentionNodes.reduce((prev: number[], node) => {
            const data = node.getData();
            const id = get(data, "id") as number;
            if (id && !prev.includes(id)) {
              prev.push(id);
            }
            return prev;
          }, []);

          setValue("mentioned_account_ids", mentionsData);
        },
        { editor }
      );
    });
  }, [editor, mentions, setValue]);
  return (
    <BeautifulMentionsPlugin
      menuItemLimit={false}
      items={mentions}
      menuComponent={LexicalEditorMentionsMenu}
      menuItemComponent={LexicalMentionsMenuItem}
    />
  );
}
